const messageRecord = () => import('@/pages/student/messageRecord');
const abroadTimetable = () => import('@/pages/student/abroadTimetable');
const caseAnalysis = () => import('@/pages/student/caseAnalysis');
const secondNode = () => import('@/pages/student/secondNode');
const ieltsTest = () => import('@/pages/student/ieltsTest');
const ieltsHistory = () => import('@/pages/student/ieltsHistory');
const evaluation = () => import('@/pages/student/evaluation');
const processList = () => import('@/pages/student/processList');
const studentIndex = () => import('./index');
const introducer = () => import('@/pages/student/introducer');
const editStudent = () => import('./editStudent');
const supplier = () => import('./supplier');
const addStudentSimple = () => import('./addStudentSimple');
const cloudDiskNoCycle = () => import('./cloudDiskNoCycle');
const processDetails = () => import('./processDetails');
const snapshotList = () => import('./snapshotList');
const snapshot = () => import('./snapshot');
const order = () => import('./orderNew');
const boarding = () => import('./boarding');
const questionAnswer = () => import('./questionAnswer');
const questionList = () => import('./questionList');
const officialList = () => import('./officials/officialList');
const details = () => import('./officials/details');
const reputation = () => import('@/pages/student/reputation');
const payList = () => import('@/pages/payment/payList');
const studentMerge = () => import('@/pages/student/mergeStudent');
const processRoute = () => import('@/pages/student/processRoute');
const visitList = () => import('@/pages/student/visitList');
const writeVisitList = () => import('@/pages/student/writeVisitList');
const studentImport = () => import('@/pages/student/studentImport');
const operateVisitList = () => import('@/pages/student/operateVisitList');
const visitReport = () => import('@/pages/student/visitReport');
const enrolReport = () => import('@/pages/student/enrolReport');
const studyAbroadPlan = () => import('@/pages/student/studyAbroadPlan');
const trainingList = () => import('@/training/pages/resource/resourceManage');
const jmOrderList2022 = () => import('@/pages/student/payment/jmOrderList2022');
const jmOrderForm2022 = () => import('@/pages/student/payment/jmOrderForm2022');
const jmOrderDetail2022 = () => import('@/pages/student/payment/jmOrderDetail2022');
const qcOrderList2022 = () => import('@/pages/student/payment/qcOrderList2022');
const qcOrderForm2022 = () => import('@/pages/student/payment/qcOrderForm2022');
const qcOrderDetail2022 = () => import('@/pages/student/payment/qcOrderDetail2022');

const studentRouter = [
  {
    path: '/student', name: 'studentIndex', component: studentIndex, meta: { c: 'student', a: 'index' }
  },
  {
    path: '/student/introducer', name: 'introducer', component: introducer, meta: { c: 'student', a: 'introducer' }
  },
  {
    path: '/student/merge', name: 'studentMerge', component: studentMerge, meta: { c: 'student', a: 'merge' }
  },
  {
    path: '/student/add', name: 'addStudent', component: editStudent, meta: { c: 'student', a: 'add' }
  },
  {
    path: '/student/addAcStudent/:acId', name: 'addStudentSimple', component: addStudentSimple, meta: { c: 'student', a: 'add' }
  },
  {
    path: '/student/addBind/:bindid', name: 'addBindStudent', component: editStudent, meta: { c: 'student', a: 'add' }
  },
  {
    path: '/student/edit/:id', name: 'editStudent', component: editStudent, meta: { c: 'student', a: 'edit' }
  },
  {
    path: '/student/visitList', name: 'visitList', component: visitList, meta: { c: 'student', a: 'visitList' }
  },
  {
    path: '/student/supplier/:id', name: 'supplier', component: supplier, meta: { c: 'student', a: 'supplier' }
  },
  {
    path: '/student/writeVisitList', name: 'writeVisitList', component: writeVisitList, meta: { c: 'student', a: 'writeVisitList' }
  },
  {
    path: '/student/order/:id', name: 'studentOrder', component: order, meta: { c: 'student', a: 'order' }
  },
  {
    path: '/student/cloudDisk/:id', name: 'cloudDisk', component: cloudDiskNoCycle, meta: { c: 'student', a: 'cloudDisk' }
  },
  {
    path: '/processList', name: 'processList', component: processList, meta: { c: 'student', a: 'processList' }
  },
  {
    path: '/student/processDetails/crmid/:crmid', name: 'processDetails', component: processDetails, meta: { c: 'student', a: 'processDetails' }
  },
  {
    path: '/messageRecord', name: 'messageRecord', component: messageRecord, meta: { c: 'process', a: 'messageRecord' }
  },
  {
    path: '/student/abroadTimetable/:id', name: 'abroadTimetable', component: abroadTimetable, meta: { c: 'student', a: 'abroadTimetable' }
  },
  {
    path: '/secondNode', name: 'secondNode', component: secondNode, meta: { c: 'secondNode', a: 'index' }
  },
  {
    path: '/caseAnalysis/:id', name: 'caseAnalysis', component: caseAnalysis, meta: { c: 'caseAnalysis', a: 'caseAnalysis' }
  },
  // 学生重复资源查看
  {
    path: '/student/snapshot/list/:crmid', name: 'resourceSnapshotList', component: snapshotList, meta: { c: 'snapshot', a: 'list' }
  },
  {
    path: '/student/snapshot/view/:crmid/:id', name: 'resourceSnapshotView', component: editStudent, meta: { c: 'snapshot', a: 'view' }
  },
  {
    path: '/student/snapshot', name: 'snapshot', component: snapshot, meta: { c: 'snapshot', a: 'index' }
  },
  {
    path: '/student/ieltsTest/:crmid', name: 'ieltsTest', component: ieltsTest, meta: { c: 'student', a: 'ieltsTest' }
  },
  {
    path: '/student/ieltsHistory/:crmid', name: 'ieltsHistory', component: ieltsHistory, meta: { c: 'student', a: 'ieltsHistory' }
  },
  {
    path: '/student/evaluation/:crmid', name: 'evaluation', component: evaluation, meta: { c: 'student', a: 'evaluation' }
  },
  {
    path: '/student/cloudDiskSimple/:id', name: 'cloudDiskSimple', component: cloudDiskNoCycle, meta: { c: 'student', a: 'cloudDiskSimple' }
  },
  {
    path: '/student/boarding', name: 'boarding', component: boarding, meta: { c: 'student', a: 'boarding' }
  },
  {
    path: '/student/questionAnswer/:crmid/:questionId', name: 'questionAnswer', component: questionAnswer, meta: { c: 'student', a: 'questionAnswer' }
  },
  {
    path: '/student/questionList/:crmid', name: 'questionList', component: questionList, meta: { c: 'student', a: 'questionList' }
  },
  // 英国  澳洲文案流程
  {
    path: '/student/officials/officialList/:country', name: 'officialList', component: officialList, meta: { c: 'student', a: 'officialList' }
  },
  {
    path: '/student/officials/details/:country/:crm_id', name: 'details', component: details, meta: { c: 'student', a: 'details' }
  },
  {
    path: '/reputation/:id', name: 'reputation', component: reputation, meta: { c: 'reputation', a: 'reputation' }
  },
  {
    path: '/payment/order/:crmid', name: 'paymentorder', component: payList, meta: { c: 'payment', a: 'order' }
  },
  // 文案流程路由
  {
    path: '/student/processRoute', name: 'processRoute', component: processRoute, meta: { c: 'student', a: 'processRoute' }
  },
  {
    path: '/student/studentImport', name: 'studentImport', component: studentImport, meta: { c: 'student', a: 'studentImport' }
  },
  {
    path: '/student/operateVisitList', name: 'operateVisitList', component: operateVisitList, meta: { c: 'student', a: 'operateVisitList' }
  },
  {
    path: '/student/signup_table/:crm_id',
    name: 'interview_signup_table',
    component: () => import('@/interview/pages/Table'),
    meta: { c: 'student', a: 'interview_signup_table', noLayout: true }
  },
  {
    path: '/student/training/:id/:customer_id',
    name: 'trainingInfo',
    component: () => import('@/training/pages/resource/resourceEdit'),
    meta: { c: 'student', a: 'training' }
  },
  {
    path: '/student/job/:id',
    name: 'jobInfo',
    component: () => import('@/job/pages/member/edit'),
    meta: { c: 'student', a: 'job' }
  },
  {
    path: '/student/visitReport', name: 'visitReport', component: visitReport, meta: { c: 'student', a: 'visitReport' }
  },
  {
    path: '/student/enrolReport', name: 'enrolReport', component: enrolReport, meta: { c: 'student', a: 'enrolReport' }
  },
  {
    path: '/student/studyAbroadPlan/:id', name: 'studyAbroadPlan', component: studyAbroadPlan, meta: { c: 'student', a: 'studyAbroadPlan' }
  },
  {
    path: '/student/trainingList', name: 'trainingList', component: trainingList, meta: { c: 'student', a: 'trainingList' }
  },
  {
    path: '/student/payment/jmOrderList/:id', name: 'userjmOrderList2022', component: jmOrderList2022, meta: { c: 'student', a: 'jmOrderList2022' }
  },
  {
    path: '/student/payment/jmOrderDetail/:id/:orderId', name: 'jmOrderDetail2022', component: jmOrderDetail2022, meta: { c: 'student', a: 'jmOrderDetail2022' }
  },
  {
    path: '/student/payment/jmOrderForm/:id/:orderId', name: 'jmOrderForm2022', component: jmOrderForm2022, meta: { c: 'student', a: 'jmOrderForm2022' }
  },
  {
    path: '/student/payment/qcOrderList/:id', name: 'userqcOrderList2022', component: qcOrderList2022, meta: { c: 'student', a: 'qcOrderList2022' }
  },
  {
    path: '/student/payment/qcOrderDetail/:id/:orderId', name: 'qcOrderDetail2022', component: qcOrderDetail2022, meta: { c: 'student', a: 'qcOrderDetail2022' }
  },
  {
    path: '/student/payment/qcOrderForm/:id/:orderId', name: 'qcOrderForm2022', component: qcOrderForm2022, meta: { c: 'student', a: 'qcOrderForm2022' }
  }
];

export default studentRouter;
